import { render, staticRenderFns } from "./CompareAnalysis.vue?vue&type=template&id=32197cd6&scoped=true"
import script from "./CompareAnalysis.vue?vue&type=script&lang=js"
export * from "./CompareAnalysis.vue?vue&type=script&lang=js"
import style0 from "./CompareAnalysis.vue?vue&type=style&index=0&id=32197cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32197cd6",
  null
  
)

export default component.exports